import * as React from 'react';

import AccessibleSVG from '../accessible-svg';

import { Icon } from '../iconTypes';

const IconAutomation = ({ className = '', color = '#FFFFFF', height = 14, title, width = 16 }: Icon) => (
    <AccessibleSVG
        className={`icon-automation ${className}`}
        height={height}
        title={title}
        viewBox="0 0 16 14"
        width={width}
    >
        <path
            className="fill-color"
            d="M4.243 5.705h.036L7.13 13.55H4.28L1.63 6.264C.678 5.912 0 4.996 0 3.924c0-1.38 1.118-2.498 2.496-2.498 1.38 0 2.496 1.118 2.496 2.497 0 .698-.287 1.33-.75 1.782zm-1.747-.713c.59 0 1.07-.48 1.07-1.07 0-.59-.48-1.07-1.07-1.07-.59 0-1.07.48-1.07 1.07 0 .59.48 1.07 1.07 1.07zM10.96 4l1.54-2.04L14.866 3.3l.825-1.337L12.103 0l-1.748 2.14H8.558v.713H5.705v2.14h2.853v.802h1.797l1.748 2.228 3.587-1.96-.825-1.338L12.5 6.062 10.96 4z"
            fill={color}
            fillRule="evenodd"
        />
    </AccessibleSVG>
);

export default IconAutomation;
